import BaseModelAPI from '../BaseModelAPI';

export default class BeritaAcaraStockOpnameList extends BaseModelAPI {

	static entity = 'beritaacarastockopnamelist'
	static entityName = 'beritaacarastockopname';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
